import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#483E59",
      "fill-rule": "evenodd",
      d: "M5.007 11.02c1.671 1.697 4.504 1.678 6.125-.082.173-.195.484-.293.713-.133.244.2.235.605.033.83-2.002 2.184-5.516 2.224-7.592.124-2.044-2.069-2.044-5.444 0-7.512 2.077-2.102 5.45-2.065 7.509.042.185.185.302.473.149.713-.189.283-.597.281-.829.05-1.852-1.596-4.292-1.945-6.108-.075-1.628 1.675-1.647 4.373 0 6.044M7.992 0a7.994 7.994 0 0 1 7.992 7.995 7.994 7.994 0 0 1-7.992 7.994A7.994 7.994 0 0 1 0 7.995 7.994 7.994 0 0 1 7.992 0m0 .766A7.227 7.227 0 0 0 .766 7.995a7.227 7.227 0 1 0 14.452 0A7.227 7.227 0 0 0 7.992.766",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "c"}) } }